import { x } from '@ui-furniture/style';

export const Image = x.img;
